import React, { useEffect, useState } from "react";
import mammoth from "mammoth";

const GapsyComplianceDescription = () => {
    const [html, setHtml] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        loadDocument();
    }, []);

    const loadDocument = async () => {
        try {
            const response = await fetch("/templates/Compliance_and_Reporting_Risk_Overview.docx");

            if (!response.ok) {
                throw new Error("Unable to load document.");
            }

            const arrayBuffer = await response.arrayBuffer();

            const result = await mammoth.convertToHtml({
                arrayBuffer
            });

            setHtml(result.value);
        } catch (err) {
            console.error(err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="card border-0 h-100 shadow-sm">
                <div className="card-body text-center">
                    Loading...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="card border-0 h-100 shadow-sm">
                <div className="card-body text-danger text-center">
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div className="card border-0 h-100 shadow-sm">
            <div
                className="card-body"
                dangerouslySetInnerHTML={{ __html: html }}
            />
        </div>
    );
};

export default GapsyComplianceDescription;